import { url } from "../utils/config";
import Table from "../reusable_components/Table";
import { useState } from "react";
import Register from "../child_components/Register";
import Button from "../reusable_components/Button";
import { btnOne, title, btnOneNoWidth } from "../utils/style";


function Managers() {
    const [showForm, setShowForm] = useState(false)
    const [reloadTable, setReloadTable] = useState(false)

    const options = [
        {
            header: 'Name',
            render: (data) => { return data.firstName + ' ' + data.lastName },
            filterKey: 'name'
        },
        {
            header: 'Phone No.',
            key: 'phone',
            filterKey: 'phone',
            placeHolder: '+1 123467890'
        },
        {
            header: 'Email Id',
            key: 'email',
            filterKey: 'email',
            placeHolder: 'user@xyz.com'
        },
        {
            header: 'Location',
            key: 'location',
            filterKey: 'location'
        }
    ]

    return (
        <div className="overflow-y-auto">
            {
                showForm ? <Register setShowForm={setShowForm} reload={setReloadTable} formType='manager' /> : null
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Managers</div>
                {(
                    <Button className={`${btnOneNoWidth}`} name={`Add Manager`} clickHandler={() => setShowForm(!showForm)} />
                )}
            </div>
            <Table
                className="max-h-[80vh] overflow-y-auto"
                options={options}
                url={url + '/managers'}
                pagination
                clickHandler={() => setShowForm(!showForm)}
                btnTitle='Manager'
                reloadTable={reloadTable}
                noButton={true}
            />
        </div>
    )
}

export default Managers;